import React from 'react';
const UserMeContext = React.createContext({
  userMe: {},
});

export default UserMeContext;
